export default __webpack_public_path__ + "static/media/ResearchInbal.7c76dfd4.svg";